// Users.js
import React, { useState, useEffect } from 'react';
import './Users.css';
import { getMessages, getUsers, getUserTokensByDate } from './api';
import { updateUser } from './api';
import { sendMessageToUsers } from './api';
import MessagesModal from '../messages/MessagesModal';

const Users = ({ logOut }) => {
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
    const [filters, setFilters] = useState({ username: '', status: '', source: '', tg_id: '', requests: '', totalRequests: '' });

    const [selectedUser, setSelectedUser] = useState(null);
    const [newStatus, setNewStatus] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');

    const [messages, setMessages] = useState([]);
    const [showMessagesModal, setShowMessagesModal] = useState(false);

    const [payds, setPayds] = useState([]);

    const fetchTokensData = async (userId) => {
        try {
            const data = await getUserTokensByDate(userId);
            if (data) {
                setPayds(data); // Устанавливаем данные в состояние
            }
        } catch (error) {
            console.error('Ошибка при получении данных:', error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const data = await getUsers();
            setUsers(data);
            setFilteredUsers(data);
        };
        fetchData();
    }, []);

    // const handleSort = (key) => {
    //     console.log('handleSort', key)
    //     let direction = 'ascending';
    //     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
    //         direction = 'descending';
    //     }
    //     setSortConfig({ key, direction });

    //     const sortedUsers = [...filteredUsers].sort((a, b) => {
    //         if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
    //         if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
    //         return 0;
    //     });
    //     setFilteredUsers(sortedUsers);
    // };

    const handleSort = (key) => {
        console.log('handleSort', key);
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });

        const sortedUsers = [...filteredUsers].sort((a, b) => {
            let aValue = a[key];
            let bValue = b[key];

            // Проверяем, является ли ключ 'date_reg'
            if (key === 'date_reg') {
                aValue = new Date(aValue).getTime();
                bValue = new Date(bValue).getTime();
            } else {
                // Для других ключей, используем стандартное сравнение
                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();
            }

            if (aValue < bValue) return direction === 'ascending' ? -1 : 1;
            if (aValue > bValue) return direction === 'ascending' ? 1 : -1;
            return 0;
        });

        setFilteredUsers(sortedUsers);
    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleSendMessage = async () => {
        try {
            await sendMessageToUsers(message, file);
            alert('Сообщение отправлено!');
            setShowModal(false);
            setMessage('');
            setFile(null);
        } catch (error) {
            alert(error.message);
        }
    };


    const handleRowClick = (user) => {
        console.log('handleRowClick', user)
        fetchTokensData(user.id)
        setSelectedUser(user);
        setNewStatus(user.status); // Предустанавливаем статус пользователя в модальном окне
    };

    const handleStatusChange = (e) => {
        setNewStatus(e.target.value);
    };

    // const handleSave = () => {
    //     // updateUser({ ...selectedUser, status: newStatus });
    //     updateUser({ userId: selectedUser.id, newStatus });
    //     setSelectedUser(null); // Закрываем модалку после сохранения
    // };

    const handleSave = async () => {
        const updatedUser = await updateUser({ userId: selectedUser.id, newStatus });

        if (updatedUser) {
            // Обновляем статус в `users` или `filteredUsers`
            setFilteredUsers((prevUsers) =>
                prevUsers.map((user) =>
                    user.id === selectedUser.id ? { ...user, status: newStatus } : user
                )
            );
            setSelectedUser(null); // Закрываем модалку после сохранения
        }
    };


    //   const handleFilterChange = (e) => {
    //     const { name, value } = e.target;
    //     console.log('name, value', name, value)
    //     setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));

    //     const filtered = users.filter((user) =>
    //       Object.keys(filters).every((filterKey) =>
    //         user[filterKey].toString().toLowerCase().includes(filters[filterKey].toLowerCase())
    //       )
    //     );
    //     setFilteredUsers(filtered);
    //   };


    // const handleFilterChange = (e) => {
    //     const { name, value } = e.target;

    //     // Обновляем фильтры в состоянии
    //     setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));

    //     // Фильтруем пользователей с учетом новых значений
    //     const filtered = users.filter((user) =>
    //         (!name || name !== 'username' || user.username.toLowerCase().includes(value.toLowerCase())) &&
    //         (!name || name !== 'status' || user.status.toLowerCase().includes(value.toLowerCase())) &&
    //         (!name || name !== 'source' || user.source.toLowerCase().includes(value.toLowerCase()))
    //     );

    //     setFilteredUsers(filtered);
    // };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value)

        // Обновляем фильтры в состоянии
        setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));


        // Фильтруем пользователей с учетом новых значений
        const filtered = users.filter((user) => {
            const matchesUsername = name !== 'username' || user.username.toLowerCase().includes(value.toLowerCase()) || value === '';
            const matchesStatus = name !== 'status' || user.status.toLowerCase().includes(value.toLowerCase());
            const matchesSource = name !== 'source' || user.source.toLowerCase().includes(value.toLowerCase());
            const matchesTgId = name !== 'tg_id' || (user.user_tg_id).toString().toLowerCase().includes(value.toLowerCase());

            const matchesQq = name !== 'requests' || user.qq === parseInt(value) || value === '';
            const matchesMessageCount = name !== 'totalRequests' || (user.message_count).toString().toLowerCase().includes(value.toLowerCase()) || value === '';


            // Проверяем фильтрацию по dateFrom и dateTo
            const userDateReg = new Date(user.date_reg).toISOString().split('T')[0];

            const matchesDateFrom = (name === 'dateFrom' ? userDateReg >= value : userDateReg >= filters.dateFrom) || !filters.dateFrom; // Используем value для dateFrom
            const matchesDateTo = (name === 'dateTo' ? userDateReg <= value : userDateReg <= filters.dateTo) || !filters.dateTo;

            // console.log('handleFilterChange dates', userDateReg, matchesDateFrom, matchesDateTo)

            console.log('handleFilterChange', matchesDateFrom, matchesDateTo, matchesUsername, matchesStatus, matchesSource, matchesTgId)

            return matchesUsername && matchesStatus && matchesSource && matchesDateFrom && matchesDateTo && matchesTgId && matchesMessageCount && matchesQq;
        });

        setFilteredUsers(filtered);
    };


    const handleOpenMessages = async () => {
        try {
            const userMessages = await getMessages(selectedUser.email); // Передаем ID пользователя
            setMessages(userMessages);
            setShowMessagesModal(true);
        } catch (error) {
            console.error("Ошибка при загрузке сообщений:", error);
        }
    };

    const handleLogOut = async () => {
        localStorage.removeItem('authData');
        logOut()
    }

    const tableHeaderStyle = {
        padding: '8px',
        textAlign: 'left',
        borderBottom: '2px solid #ddd'
    };

    const tableCellStyle = {
        padding: '8px',
        borderBottom: '1px solid #ddd'
    };

    return (
        <div className="table-container">
            {/* <h1>Users</h1> */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Пользователи: <span className='q_users'>{` Всего: ${users.length}    Отфильтровано: ${filteredUsers.length}`}</span></h1>
                <button onClick={() => setShowModal(true)}>Рассылка</button>
                <button onClick={handleLogOut}>Выйти</button>
            </div>
            {showModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>Отправить сообщение пользователям</h2>
                        <textarea
                            placeholder="Введите сообщение"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            rows="4"
                            style={{ width: '100%' }}
                        ></textarea>
                        <label>
                            <input type="file" onChange={handleFileChange} />
                        </label>
                        {file && <p>Выбран файл: {file.name}</p>}
                        <button onClick={handleSendMessage}>Отправить</button>
                        <button onClick={() => setShowModal(false)}>Закрыть</button>
                    </div>
                </div>
            )}

            {/* <div className="filter-container">
                <label>
                    Username:
                    <input
                        type="text"
                        name="username"
                        value={filters.username}
                        onChange={handleFilterChange}
                        placeholder="Filter by username"
                    />
                </label>
                <label>
                    Status:
                    <input
                        type="text"
                        name="status"
                        value={filters.status}
                        onChange={handleFilterChange}
                        placeholder="Filter by status"
                    />
                </label>
                <label>
                    Source:
                    <input
                        type="text"
                        name="source"
                        value={filters.source}
                        onChange={handleFilterChange}
                        placeholder="Filter by source"
                    />
                </label>
            </div> */}

            <div className="filter-container">
                <label className='filter_label'>
                    Имя:
                    <input
                        type="text"
                        name="username"
                        value={filters.username}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по имени"
                    />
                </label>
                <label className='filter_label'>
                    TG_ID:
                    <input
                        type="text"
                        name="tg_id"
                        value={filters.tg_id}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по TG_ID"
                    />
                </label>
                <label className='filter_label'>
                    Статус:
                    <input
                        type="text"
                        name="status"
                        value={filters.status}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по статусу"
                    />
                </label>
                <label className='filter_label'>
                    Запросы:
                    <input
                        type="text"
                        name="requests"
                        value={filters.requests}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по запросам"
                    />
                </label>

                <label className='filter_label'>
                    Всего запросов:
                    <input
                        type="text"
                        name="totalRequests"
                        value={filters.totalRequests}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по общему количеству запросов"
                    />
                </label>

                <label className='filter_label'>
                    Источник:
                    <input
                        type="text"
                        name="source"
                        value={filters.source}
                        onChange={handleFilterChange}
                        placeholder="Фильтр по источнику"
                    />
                </label>
                <label className='filter_label'>
                    Дата начало:
                    <input
                        type="date"
                        name="dateFrom"
                        value={filters.dateFrom}
                        onChange={handleFilterChange}
                    />
                </label>
                <label className='filter_label'>
                    Дата конец:
                    <input
                        type="date"
                        name="dateTo"
                        value={filters.dateTo}
                        onChange={handleFilterChange}
                    />
                </label>
            </div>


            <table className="users-table">
                <thead>
                    <tr>
                        <th onClick={() => handleSort('id')}>ID</th>
                        <th onClick={() => handleSort('username')}>Имя</th>
                        <th onClick={() => handleSort('user_tg_id')}>TG ID</th>
                        <th onClick={() => handleSort('status')}>Статус</th>
                        <th onClick={() => handleSort('qq')}>Запросы</th>
                        <th onClick={() => handleSort('qq')}>Всего запросов</th>
                        <th onClick={() => handleSort('qq')}>Токены 5р</th>
                        <th onClick={() => handleSort('qq')}>Токены 0.1р</th>
                        <th onClick={() => handleSort('qq')}>Баланс руб</th>
                        {/* <th onClick={() => handleSort('status_dialog')}>Status Dialog</th> */}
                        <th onClick={() => handleSort('source')}>Источник</th>
                        <th onClick={() => handleSort('date_reg')}>Дата регистрации</th>
                        <th onClick={() => handleSort('key')}>Ключ</th>
                        <th onClick={() => handleSort('key_now')}>Действует</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredUsers.map((user) => (
                        <tr key={user.email} onClick={() => handleRowClick(user)}>
                            <td>{user.id}</td>
                            {/* <td>{user.username}</td> */}
                            <td>{user.email}</td>
                            <td>{user.user_tg_id[0] || user.user_tg_id[1]}</td>
                            <td>{user.status}</td>
                            <td>{user.today_message_count}</td>



                            <td>{user.message_count}</td>
                            <td>{user.total_tokens5}</td>
                            <td>{user.total_tokens01}</td>
                            <td>{user.balance}</td>
                            {/* <td>{user.status_dialog}</td> */}
                            <td>{user.source}</td>
                            <td>{user.date_reg ? user.date_reg.slice(0, 10) : ''}</td>
                            <td>{user.has_key ? "✅ Есть" : "❌ Нет"}</td>
                            <td>{user.is_key_active ? "🟢 Активен" : "🔴 Неактивен"}</td>

                        </tr>
                    ))}
                </tbody>
            </table>

            {selectedUser && !showMessagesModal && (
                <div className="modal">
                    <div className="modal-content">
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px' }}>
                            <div className='user_info'>
                                <h2>Карточка пользователя</h2>
                                <p><strong>ID:</strong> {selectedUser.id}</p>
                                {/* <p><strong>Имя:</strong> {selectedUser.username}</p> */}
                                <p><strong>Имя:</strong> {selectedUser.email}</p>
                                <p><strong>TG ID:</strong> {selectedUser.user_tg_id}</p>
                                <p><strong>Источник:</strong> {selectedUser.source}</p>
                                <label>
                                    Статус:
                                    <select value={newStatus} onChange={handleStatusChange}>
                                        <option value="default">Default</option>
                                        <option value="manager">Manager</option>
                                        <option value="unlimited">Unlimited</option>
                                        <option value="blocked">Blocked</option>
                                    </select>

                                </label>
                                <div className='cntr_btn'>
                                    <button onClick={handleSave}>Сохранить</button>
                                    <button onClick={() => setSelectedUser(null)}>Закрыть</button>
                                    <button onClick={handleOpenMessages}>Переписка</button>
                                </div>
                            </div>
                            <div className='payds_info'>
                                <h5>Список токенов по датам</h5>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ background: '#f9f9f9', borderBottom: '2px solid #ddd', fontSize: '12px' }}>
                                            <th style={tableHeaderStyle}>Дата</th>
                                            <th style={tableHeaderStyle}>Токены 5</th>
                                            <th style={tableHeaderStyle}>Токены 01</th>
                                            <th style={tableHeaderStyle}>Сумма в рублях</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payds.length > 0 ? (
                                            payds.map((payd, index) => {
                                                const formattedDate = new Intl.DateTimeFormat('ru-RU').format(new Date(payd.date));
                                                return (
                                                    <tr key={index} style={{ borderBottom: '1px solid #ddd', fontSize: '12px' }}>
                                                        <td style={tableCellStyle}>{formattedDate}</td>
                                                        <td style={tableCellStyle}>{payd.total_tokens5}</td>
                                                        <td style={tableCellStyle}>{payd.total_tokens01}</td>
                                                        <td style={tableCellStyle}>{payd.total_rub}</td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'center', padding: '10px' }}>Нет данных</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>

                </div>
            )}

            <MessagesModal
                show={showMessagesModal}
                onClose={() => setShowMessagesModal(false)}
                messages={messages}
                setMessages={setMessages}
                selectedUser={selectedUser}
            />

        </div>
    );
};

export default Users;

